"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const losses_1 = require("../losses");
const date_fns_1 = require("date-fns");
const address_1 = __importDefault(require("../../address"));
class Location {
    constructor(data) {
        this.locationNo = data.locationNo;
        this.buildingNo = data.buildingNo;
        this.address = address_1.default.fromObj(data.address);
        this.occupancy = data.occupancy;
        this.thirdPartyLocation = data.thirdPartyLocation;
        this.maximunInventoryValue = data.maximunInventoryValue;
        this.constructionType = data.constructionType;
        this.yearBuilt = data.yearBuilt;
        this.yearLastRoofUpdate = data.yearLastRoofUpdate;
        this.primaryCommodity = data.primaryCommodity;
        this.secondaryCommodities = data.secondaryCommodities;
        this.commodityState = data.commodityState;
        this.desiredLimit = data.desiredLimit;
        this.desiredDeductible = data.desiredDeductible;
        this.desiredNATCATPerilsSublimit = data.desiredNATCATPerilsSublimit;
        this.securityProtectionsInPlace = data.securityProtectionsInPlace;
        this.locationLossesLastFiveYears = data.locationLossesLastFiveYears;
        this.claimsHistory = data.claimsHistory;
        this.yearsOfClaimHistory = data.yearsOfClaimHistory;
    }
    static empty() {
        const data = {
            locationNo: 0,
            buildingNo: "",
            address: address_1.default.empty(),
            occupancy: "",
            thirdPartyLocation: undefined,
            maximunInventoryValue: undefined,
            constructionType: "",
            yearBuilt: "",
            yearLastRoofUpdate: "",
            primaryCommodity: "",
            secondaryCommodities: [],
            commodityState: "",
            desiredLimit: null,
            desiredDeductible: null,
            desiredNATCATPerilsSublimit: null,
            securityProtectionsInPlace: [],
            locationLossesLastFiveYears: false,
            claimsHistory: [],
            yearsOfClaimHistory: 5,
            lossRecordAvailable: undefined,
            lossRecordDocuments: undefined
        };
        const newLocation = new Location(data);
        const minYear = 2018;
        const years = date_fns_1.getYear(new Date()) - minYear;
        newLocation.claimsHistory = Location.getClaimsHistoryStructure(data.yearsOfClaimHistory || years);
        return newLocation;
    }
    static fromObj(data) {
        if (!data) {
            return Location.empty();
        }
        const claimsHistory = data.claimsHistory
            ? losses_1.ClaimHistoryRecord.getRecords(data.claimsHistory)
            : [];
        return new Location(Object.assign(Object.assign({}, data), { claimsHistory }));
    }
    static getClaimsHistoryStructure(years) {
        const claimsHistory = [];
        if (years > 0) {
            for (let i = 0; i < years; i += 1) {
                const year = date_fns_1.subYears(new Date(), i);
                const claimsHistoryToPush = new losses_1.ClaimHistoryRecord({
                    year: date_fns_1.getYear(year),
                    totalGrossLosses: null,
                    numberOfLosses: null
                });
                claimsHistory.push(claimsHistoryToPush);
            }
        }
        return claimsHistory;
    }
}
exports.default = Location;
//# sourceMappingURL=location.class.js.map